import React from 'react'
import styles from './PillSwitcher.module.css'

const PillSwitcher = ({ activeView, onViewChange }) => {
    return (
        <div className={styles.pillContainer}>
            <button
                className={`${styles.pill} ${activeView === 'shortlist' ? styles.active : ''}`}
                onClick={() => onViewChange('shortlist')}
                data-tooltip="Your weekly top 20, with tailored actions for each"
            >
                Weekly Shortlist
            </button>
            <button
                className={`${styles.pill} ${activeView === 'feed' ? styles.active : ''}`}
                onClick={() => onViewChange('feed')}
                data-tooltip="Your complete stream of everything out there"
            >
                Feed
            </button>
            <button
                className={`${styles.pill} ${activeView === 'graph' ? styles.active : ''}`}
                onClick={() => onViewChange('graph')}
                data-tooltip="The same feed in a visual universe built around you."
            >
                Graph View
            </button>
        </div>
    )
}

export default PillSwitcher
